<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :to="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="7" class="pt-1">
          <span class="headline font-weight-medium">Kárdex</span>
          <br />
          <storehouse-breadcrumb></storehouse-breadcrumb>
        </v-col>
        <v-col cols="5">
          <span class="title font-weight-medium text-uppercase float-right">
            ({{ inventory.description }})
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="1">
          <span>DESDE: </span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-menu
            v-model="menuInit"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_init"
                readonly
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_init"
              @input="menuInit = false"
              no-title
              locale="es"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="1">
          <span>HASTA: </span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-menu
            v-model="menuEnd"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_end"
                readonly
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_end"
              @input="menuEnd = false"
              no-title
              locale="es"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="pt-2">
          <v-btn color="green" dark @click="getAllKardex">
            Listar
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title class="pt-0 pb-0">
              <span
                class="ml-1 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >Todos los movimientos</span
              >
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-0 pl-0 pr-0">
              <v-simple-table dense height="63vh" class="table-kardex">
                <thead class="table-kardex-head">
                  <tr>
                    <th class="text-left text-uppercase" rowspan="2">Fecha</th>
                    <th
                      class="text-left text-uppercase column-hora"
                      rowspan="2"
                    >
                      Hora
                    </th>
                    <th
                      class="text-left text-uppercase column-tipo-movimiento"
                      rowspan="2"
                    >
                      Tip. Movimiento
                    </th>
                    <th
                      class="text-left text-uppercase column-movimiento"
                      rowspan="2"
                    >
                      Movimiento
                    </th>
                    <th
                      class="text-left text-uppercase column-movimiento"
                      rowspan="2"
                    >
                      Destino
                    </th>
                    <th
                      class="text-left text-uppercase column-tipo-documento"
                      rowspan="2"
                    >
                      Tipo Doc.
                    </th>
                    <th class="text-left text-uppercase" rowspan="2">Serie</th>
                    <th class="text-left text-uppercase" rowspan="2">Número</th>
                    <th class="text-center text-uppercase" colspan="3">
                      Entrada
                    </th>
                    <th class="text-center text-uppercase" colspan="3">
                      Salida
                    </th>
                    <th class="text-center text-uppercase" colspan="3">
                      Existencias
                    </th>
                  </tr>
                  <tr>
                    <th class="text-center text-uppercase">Cant.</th>
                    <th class="text-center text-uppercase">Costo</th>
                    <th class="text-center text-uppercase">Total</th>

                    <th class="text-center text-uppercase">Cant.</th>
                    <th class="text-center text-uppercase">Costo</th>
                    <th class="text-center text-uppercase">Total</th>

                    <th class="text-center text-uppercase">Cant.</th>
                    <th class="text-center text-uppercase">Costo</th>
                    <th class="text-center text-uppercase">Total</th>
                  </tr>
                </thead>

                <tbody class="table-kardex-body">
                  <tr v-for="item in kardex" :key="item.id">
                    <td>{{ item.operation_date | moment("DD/MM/YYYY") }}</td>
                    <td>{{ item.operation_date | moment("hh:mm a") }}</td>
                    <td>{{ item.type }}</td>
                    <td>
                      {{ item.subtype }}
                    </td>
                    <td>
                      <div v-if="item.subtype == 'TRANSFERENCIA'">
                        <label for="" v-if="item.type == 'SALIDA'">{{
                          item.destination
                        }}</label>
                        <label for="" v-else-if="item.type == 'INGRESO'">
                          {{ item.origin }}</label
                        >
                      </div>
                      <div v-else-if="item.area_id">
                        <label for="">{{ item.areas_name }}</label>
                      </div>
                      <div v-else></div>
                    </td>
                    <td>{{ item.type_document }}</td>
                    <td>{{ item.serie }}</td>
                    <td>{{ item.correlative }}</td>
                    <td>
                      <span class="label-quantity-entry">{{
                        item.quantity_entry
                      }}</span>
                    </td>
                    <td>
                      <span>{{ item.cost_entry | currency("S/") }}</span>
                    </td>
                    <td>
                      <span>{{ item.total_entry | currency("S/") }}</span>
                    </td>
                    <td>
                      <span
                        v-if="item.subtype == 'MERMA'"
                        class="label-quantity-merma"
                        >{{ item.quantity_output }}</span
                      >
                      <span
                        v-else-if="item.subtype == 'CONSUMO INTERNO'"
                        class="label-quantity-interno"
                        >{{ item.quantity_output }}</span
                      >
                      <span v-else class="label-quantity-output">{{
                        item.quantity_output
                      }}</span>
                    </td>
                    <td>
                      <span>{{ item.cost_output | currency("S/") }}</span>
                    </td>
                    <td>
                      <span>{{ item.total_output | currency("S/") }}</span>
                    </td>
                    <td>
                      <span class="label-quantity-stock">{{ item.stock }}</span>
                    </td>
                    <td>
                      <span>{{ item.cost_stock | currency("S/") }}</span>
                    </td>
                    <td>
                      <span>{{ item.total_stock | currency("S/") }}</span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import StorehouseBreadcrumb from "../../../components/storehouses/StorehouseBreadcrumb";

export default {
  name: "Kardex",
  components: {
    StorehouseBreadcrumb,
    OfficeLogin,
  },
  data() {
    return {
      itemsBreadcrumbs: [
        {
          text: "Logística",
          disabled: true,
          href: "",
        },
        {
          text: "Almacenes",
          disabled: false,
          href: "/app/logistica/almacenes",
        },
      ],
      headers: [
        { text: "FECHA", value: "operation_date" },
        { text: "HORA", value: "operation_date" },
        { text: "MOVIMIENTO", value: "type" },
        { text: "TIPO. DOC", value: "type_document" },
        { text: "NUM. DOC", value: "serie" },
        { text: "", value: "actions" },
      ],
      menuInit: false,
      menuEnd: false,
      date_init: this.$moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      date_end: this.$moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState("inventories", [
      "inventory",
      "kardex",
      "office_name",
      "sede_name",
      "company_name",
    ]),
  },
  methods: {
    ...mapActions("inventories", ["getKardex", "clean_kardex"]),
    async getAllKardex() {
      let filters = {
        inventory_id: this.inventory.id,
        date_init: this.date_init,
        date_end: this.date_end,
      };
      await this.getKardex(filters);
    },
  },
  created() {
    this.date_init = this.$moment()
      .subtract(7, "days")
      .format("YYYY-MM-DD");
    this.date_end = this.$moment().format("YYYY-MM-DD");
  },
  mounted() {
    this.getAllKardex();
  },
  destroyed() {
    this.clean_kardex();
  },
};
</script>

<style scoped>
.table-kardex {
  overflow-y: auto;
}
.table-kardex-head {
  background-color: #f2f2f2 !important;
}

.label-quantity-entry {
  background-color: #43a047;
  color: #ffffff;
  display: block;
  width: 50px;
  text-align: center;
  border-radius: 4px;
}

.label-quantity-output {
  background-color: #e53935;
  color: #ffffff;
  display: block;
  width: 50px;
  text-align: center;
  border-radius: 4px;
}

.label-quantity-stock {
  background-color: #3f51b5;
  color: #ffffff;
  display: block;
  width: 50px;
  text-align: center;
  border-radius: 4px;
}

.label-quantity-merma {
  background-color: #ffc107;
  color: #ffffff;
  display: block;
  width: 50px;
  text-align: center;
  border-radius: 4px;
}

.label-quantity-interno {
  background-color: #9c27b0;
  color: #ffffff;
  display: block;
  width: 50px;
  text-align: center;
  border-radius: 4px;
}

.column-hora {
  width: 70px !important;
  min-width: 70px !important;
}

.column-movimiento {
  max-width: 200px !important;
  min-width: 100px !important;
}

.table-kardex-body td {
  height: 40px !important;
}

.table-kardex td,
.table-kardex th {
  padding: 0 2px !important;
}
</style>
